import React from "react"
import types from "prop-types"
import { RemoveButton } from "shared/buttons"
import ItemRow from "shared/ItemRow"
import UserInfo from "./UserInfo"

const SearchSelectedUser = ({
  children = null,
  user,
  deselect,
}) => (
  <ItemRow
    className="relative"
    itemRowHeaderControls={(
      <RemoveButton className="mr-2" icon="close" onClick={deselect} ariaLabel="remove user" />
    )}
    itemRowHeaderContent={(
      <UserInfo user={user}>
        {children}
      </UserInfo>
    )}
  />
)

SearchSelectedUser.propTypes = {
  children: types.node,
  deselect: types.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  user: types.object.isRequired,
}

export default SearchSelectedUser
